var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"c-reference-news"},[(_vm.noContent)?_c('h5',[_vm._v(_vm._s(_vm.$t('message.not_exist')))]):_vm._e(),_c('div',{on:{"click":_vm.handleDetail}},[_vm._v(_vm._s(_vm.news.body))])])])}
var staticRenderFns = []

export { render, staticRenderFns }